<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <list-component
      :service="service"
      :tableMetaData="tableMetaData"
    ></list-component>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import ListComponent from '../../../components/ListComponent.vue';
import services from '../../../services';

const { documentRegistry } = services;
const { permitService } = documentRegistry;

export default {
  name: 'PermitList',
  components: {
    LandingCreate,
    ListComponent,
  },
  data() {
    const component = this;
    return {
      service: permitService,
      content: {
        pageTitle: 'Permit',
        commands: [
          {
            link: 'permit.create',
            icon: 'mdi-plus-box',
            buttonName: 'Create',
          },
        ],
      },
      tableMetaData: {
        tableFilters: {
          selections: [],
          dates: [
            {
              text: 'Date created',
              column: 'dateCreated',
            },
          ],
        },
        tableHeaders: [
          {
            text: 'Name',
            value: 'name',
          },
          {
            text: 'Description',
            value: 'description',
          },
          {
            text: 'Created by',
            value: '_metadata.created.user.fullName',
          },
          {
            text: 'Date created',
            value: '_metadata.created.date',
          },
          {
            text: 'Actions',
            value: 'actions',
          },
        ],
        actions: {
          view: false,
        },
        URLName: 'permit',
        actionDisplay: {
          delete: {
            visible: true,
            icon: () => 'mdi-delete-empty',
          },
        },
        onClickArchive(item) {
          component.onArchive(item);
        },
      },
    };
  },
  methods: {
    async onArchive(item) {
      this.isLoading = true;
      try {
        await permitService.archive({ permit: item });
        this.$snackbar.show({
          text: 'Successfully deleted Permit!',
          closeColor: 'white',
          color: 'green',
        });
      } catch (e) {
        const { message } = e.response.data;
        this.$snackbar.show({ color: 'red', text: message, closeColor: 'white' });
      }
      this.isLoading = false;
    },
  },
};
</script>
